import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Audio5 = () => {
  return (
    <div>
      <Navbar />
      <main id="main-section" className="px-5 md:px-80">
        {/* HEADINGS */}
        <div id="headings">
          <h1 className="text-[#314C1C] text-2xl text-center font-bold pt-12">
            AUDIOS
          </h1>
          <h1 className="text-[#314C1C] text-lg text-center font-semibold pt-10">
            RELIEF TRACKS
          </h1>
        </div>
        {/* FIRST SECTION */}
        <section className="mt-12">
          <div className="space-y-6 md:grid md:grid-cols-2 md:justify-center md:items-center md:place-content-center">
            <Link
              to="./audios_1-4/Peaceful-and-calming-atmosphere-song-with-nature-sounds.mp3"
              target="_blank"
            >
              <img
                src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1700655217/fyp6vzboyimlhmjytnfx.png"
                alt="audio-img"
                className="w-full md:w-[270px] md:h-[200px] rounded-md text-center object-cover"
              />
            </Link>
            <div className="md:space-y-10 md:text-center md:pl-20">
              <button
                type="button"
                className="text-[whitesmoke] font-medium border-2 bg-[#314C1C] w-full p-2 rounded-md"
              >
                ADD TO LIST
              </button>
              <Link
                to="./audios_1-4/Peaceful-and-calming-atmosphere-song-with-nature-sounds.mp3"
                download
              >
                <button
                  type="button"
                  className="text-[whitesmoke] font-medium border-2 bg-[#314C1C] w-full p-2 rounded-md"
                >
                  DOWNLOAD <i className="fa-solid fa-download"> </i>
                </button>
              </Link>
            </div>
          </div>
        </section>
        {/* SECOND SECTION */}
        <section className="mt-10 md:mt-16 content-center justify-center items-center place-content-center">
          <div className="content-center justify-center items-center place-content-center">
            <p className="text-[#314C1C] text-sm text-justify">
              Escape the chaos of everyday life and immerse yourself in a world
              of tranquility with our curated collection of relaxation audio.
              Tranquil Soundscapes is your sanctuary for peace, serenity, and
              rejuvenation. Whether you're seeking stress relief, better sleep,
              or a moment of mindfulness, our carefully crafted audio
              experiences are designed to transport you to a state of deep
              relaxation. Let the soothing sounds of nature, from gentle waves
              to rustling leaves, create a calming ambiance that connects you
              with the natural world.
            </p>
            <div className="flex justify-between mt-12 mb-12">
              <Link to="/mainaudiopage">
                <button
                  type="button"
                  className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-28 p-2 rounded-md"
                >
                  BACK
                </button>
              </Link>
              <Link to="/mainresources">
                <button
                  type="button"
                  className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-48 p-2 rounded-md"
                >
                  BACK TO RESOURCES
                </button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Audio5;
